import { ReactElement, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Chip, ChipOwnProps } from "@mui/material";
const translationsPath =
  "page.4uSalesContract.registers.salesContractBeneficiary.";

type TCode = "1" | "2" | "3" | "4" | "5";

const SituationChip = ({
  name,
  code,
}: {
  name: string;
  code: TCode;
}): ReactElement => {
  const { t } = useTranslation();

  const translate = (path: string): string => t(translationsPath + path);

  const color = useMemo((): ChipOwnProps["color"] => {
    switch (code) {
      case "1":
        return "success";
      case "2":
        return "error";
      case "3":
        return "primary";
      case "4":
        return "secondary";
      case "5":
        return "warning";
      default:
        return;
    }
  }, [code]);

  const label = () => {
    switch (code) {
      case "1":
        return translate("approved");
      case "2":
        return translate("canceled");
      case "3":
        return translate("under_analysis");
      case "4":
        return translate("rescinded");
      case "5":
        return translate("suspended");
      default:
        return name;
    }
  };

  return <Chip size="small" color={color} label={label()} />;
};

export default SituationChip;
